export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.footerSetting = payload;

  return newState;
};
